import { Component, OnInit, Input } from '@angular/core';
import { ApiService } from './../../shared/api.service';
import { Router, ActivatedRoute } from '@angular/router';
import { saveAs } from 'file-saver';
import { FormBuilder, FormGroup , Validators} from '@angular/forms';
import { NbDialogRef } from '@nebular/theme';
import { UserService } from './../../@core/data/users.service';



@Component({
  selector: 'educational',
  templateUrl: "./educationalformbaf.component.html"
})
export class EducationalFormBafComponent implements OnInit {
  FeedbackForm : FormGroup;
  @Input() user_id: any;
  @Input() edu_id: any;
  @Input() amount_paid:string;
  @Input() admin_show:string;
  validations_flag = false;
  feedback_message ;
  showExperience = false;

  edu_form: FormGroup;
  years_array;
  courseValidation = true;
  collegeYearValidation = true;
  monthValidation  = true;
  yearValidation = true;
  attemptValidation  = true;
  semesterValidation  = true;
  instructionValidation = true;
  edu_data;
  course_data;
  user: any;

  constructor(protected api : ApiService,
    private router: Router,
    private userService: UserService,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    protected ref: NbDialogRef<EducationalFormBafComponent>) { }

  async ngOnInit() {
    // this.userService.onUserChange()
    // .subscribe((user: any) => this.user = user);
    // if(this.user.role == 'admin'){
    //   this.admin_show = false;
    // }

    this.edu_form = this.formBuilder.group({
      courseNameCtrl: [ '' ,  Validators.required],
      collegeYearCtrl : [ '' ,  Validators.required],
      semesterCtrl : [ '' ,  Validators.required],
      monthCtrl : [ '' ,  Validators.required],
      yearCtrl : [ '' ,  Validators.required],
      overmarksobtCtrl : [ '' ,  Validators.required],
      overmarksoutCtrl : [ '' ,  Validators.required],
      subjectFirstCtrl : [ '' ,  Validators.required],
      markFirstCtrl : [ '' ,  Validators.required],
      markFirstOutCtrl : [ '' ,  Validators.required],
      subjectSecondCtrl : [ '' ,  Validators.required],
      markSecondCtrl : [ '' ,  Validators.required],
      markSecondOutCtrl : [ '' ,  Validators.required],
      subjectThirdCtrl : [ '' ,  Validators.required],
      markThirdCtrl : [ '' ,  Validators.required],
      markThirdOutCtrl : [ '' ,  Validators.required],
      subjectFourthCtrl : [ '' ,  Validators.required],
      markFourthCtrl : [ '' ,  Validators.required],
      markFourthOutCtrl : [ '' ,  Validators.required],
      subjectFifthCtrl : [ ''],
      markFifthCtrl : [ '' ],
      markFifthOutCtrl : [ '' ],
      subjectSixthCtrl : [ '' ],
      markSixthCtrl : [ ''],
      markSixthOutCtrl : [ ''],
      subjectSeventhCtrl : [ ''],
      markSeventhCtrl : [ ''],
      markSeventhOutCtrl : [ ''],
      subjectEighthCtrl : [ ''],
      markEighthCtrl : [ ''],
      markEighthOutCtrl: [ ''],
      instructionCtrl : [ '' ,  Validators.required],
      lecturehourFirstCtrl : [ ''],
      lecturehourSecondCtrl : [ ''],
      lecturehourThirdCtrl : [ ''],
      lecturehourFourthCtrl : [ ''],
      lecturehourFifthCtrl : [ ''],
      lecturehourSixCtrl : [ ''],
      lecturehourSeventhCtrl : [ ''],
      lecturehourEighthCtrl : [ ''],
      practicalhourFirstCtrl : [ ''],
      practicalhourSecondCtrl : [ ''],
      practicalhourThirdCtrl : [ ''],
      practicalhourFourthCtrl : [ ''],
      practicalhourFifthCtrl : [ ''],
      practicalhourSixCtrl : [ ''],
      practicalhourSeventhCtrl : [ ''],
      practicalhourEighthCtrl : [ ''],
      specialInstrctionCtrl: [ ''],
      totalweeksCtrl : [ ''],
    })

    this.api.getCouses()
      .subscribe(
        (data: any) => { 
          if(data['status'] == 200){
            this.course_data = data['data'];
            
          }else{

          }
    });


    const now = new Date().getUTCFullYear();    
    this.years_array = Array(now - (now - 50)).fill('').map((v, idx) => now - idx);
    
    
    if(this.user_id != null){
      this.api.getEducation(this.edu_id,this.user_id)
      .subscribe(
        (data: any) => { 
          if(data['status'] == 200){
            this.edu_data = data['data'];
           
          }else{
            
          }
      });
    }
  }

  saveEdu() {
    this.courseValidation = true;
    this.collegeYearValidation = true;
    this.monthValidation = true;
    this.yearValidation = true;
    this.attemptValidation = true;
    this.instructionValidation = true;
    this.semesterValidation = true;
    if (this.edu_form.valid==false){
      this.edu_form.controls.courseNameCtrl.markAsDirty();
      this.edu_form.controls.overmarksoutCtrl.markAsDirty();
      this.edu_form.controls.overmarksobtCtrl.markAsDirty();
      this.edu_form.controls.subjectFirstCtrl.markAsDirty();
      this.edu_form.controls.markFirstCtrl.markAsDirty();
      this.edu_form.controls.markFirstOutCtrl.markAsDirty();
      this.edu_form.controls.subjectSecondCtrl.markAsDirty();
      this.edu_form.controls.markSecondCtrl.markAsDirty();
      this.edu_form.controls.markSecondOutCtrl.markAsDirty();
      this.edu_form.controls.subjectThirdCtrl.markAsDirty();
      this.edu_form.controls.markThirdCtrl.markAsDirty();
      this.edu_form.controls.markThirdOutCtrl.markAsDirty();
      this.edu_form.controls.subjectFourthCtrl.markAsDirty();
      this.edu_form.controls.markFourthCtrl.markAsDirty();
      this.edu_form.controls.markFourthOutCtrl.markAsDirty();
      this.edu_form.controls.instructionCtrl.markAsDirty();

      if(this.edu_form.controls.instructionCtrl.value === null || this.edu_form.controls.instructionCtrl.value ==='' || this.edu_form.controls.instructionCtrl.value ===undefined){
        this.instructionValidation = false;
      }else {
        this.instructionValidation = true;
      }

      if(this.edu_form.controls.courseNameCtrl.value === null || this.edu_form.controls.courseNameCtrl.value ==='' || this.edu_form.controls.courseNameCtrl.value ===undefined){
        this.courseValidation = false;
      }else {
        this.courseValidation = true;
      }
      
      if(this.edu_form.controls.collegeYearCtrl.value === null || this.edu_form.controls.collegeYearCtrl.value ==='' || this.edu_form.controls.collegeYearCtrl.value ===undefined){
        this.collegeYearValidation = false;
      }else {
        this.collegeYearValidation = true;
      }

      if(this.edu_form.controls.semesterCtrl.value === null || this.edu_form.controls.semesterCtrl.value ==='' || this.edu_form.controls.semesterCtrl.value ===undefined){
        this.semesterValidation = false;
      }else {
        this.semesterValidation = true;
      }

      if(this.edu_form.controls.monthCtrl.value === null || this.edu_form.controls.monthCtrl.value ==='' || this.edu_form.controls.monthCtrl.value ===undefined){
        this.monthValidation = false;
      }else {
        this.monthValidation = true;
      }

      if(this.edu_form.controls.yearCtrl.value === null || this.edu_form.controls.yearCtrl.value ==='' || this.edu_form.controls.yearCtrl.value ===undefined){
        this.yearValidation = false;
      }else {
        this.yearValidation = true;
      }
    }else{
      var edu_data ={
        courseName : this.edu_form.controls.courseNameCtrl.value,
        collegeYear : this.edu_form.controls.collegeYearCtrl.value,
        semester: this.edu_form.controls.semesterCtrl.value,
        month : this.edu_form.controls.monthCtrl.value,
        year : this.edu_form.controls.yearCtrl.value,
        overall_marks_obt : this.edu_form.controls.overmarksobtCtrl.value,
        overall_marks_out : this.edu_form.controls.overmarksoutCtrl.value,
        subjectFirst : this.edu_form.controls.subjectFirstCtrl.value,
        marks_obt_First : this.edu_form.controls.markFirstCtrl.value,
        marks_out_First: this.edu_form.controls.markFirstOutCtrl.value,
        subjectSecond : this.edu_form.controls.subjectSecondCtrl.value,
        marks_obt_Second: this.edu_form.controls.markSecondCtrl.value,
        marks_out_Second: this.edu_form.controls.markSecondOutCtrl.value,
        subjectThird : this.edu_form.controls.subjectThirdCtrl.value,
        marks_obt_Third : this.edu_form.controls.markThirdCtrl.value,
        marks_out_Third : this.edu_form.controls.markThirdOutCtrl.value,
        subjectFourth : this.edu_form.controls.subjectFourthCtrl.value,
        marks_obt_Fourth : this.edu_form.controls.markFourthCtrl.value,
        marks_out_Fourth : this.edu_form.controls.markFourthOutCtrl.value,
        subjectFifth : this.edu_form.controls.subjectFifthCtrl.value,
        marks_obt_Fifth : this.edu_form.controls.markFifthCtrl.value,
        marks_out_Fifth : this.edu_form.controls.markFifthOutCtrl.value,
        subjectSixth : this.edu_form.controls.subjectSixthCtrl.value,
        marks_obt_Six : this.edu_form.controls.markSixthCtrl.value,
        marks_out_Six : this.edu_form.controls.markSixthOutCtrl.value,
        subjectSeventh : this.edu_form.controls.subjectSeventhCtrl.value,
        marks_obt_Seventh : this.edu_form.controls.markSeventhCtrl.value,
        marks_out_Seventh : this.edu_form.controls.markSeventhOutCtrl.value,
        subjectEighth : this.edu_form.controls.subjectEighthCtrl.value,
        marks_obt_Eighth : this.edu_form.controls.markEighthCtrl.value,
        marks_out_Eighth : this.edu_form.controls.markEighthOutCtrl.value,
        user_id : this.user_id,
        medium_instruction : this.edu_form.controls.instructionCtrl.value,
        id : this.edu_id,
        lecture_hour_First : this.edu_form.controls.lecturehourFirstCtrl.value,
        lecture_hour_Second : this.edu_form.controls.lecturehourSecondCtrl.value,
        lecture_hour_Third : this.edu_form.controls.lecturehourThirdCtrl.value,
        lecture_hour_Fourth : this.edu_form.controls.lecturehourFourthCtrl.value,
        lecture_hour_Fifth : this.edu_form.controls.lecturehourFifthCtrl.value,
        lecture_hour_Six : this.edu_form.controls.lecturehourSixCtrl.value,
        lecture_hour_Seventh : this.edu_form.controls.lecturehourSeventhCtrl.value,
        lecture_hour_Eighth : this.edu_form.controls.lecturehourEighthCtrl.value,
        practical_hour_First : this.edu_form.controls.practicalhourFirstCtrl.value,
        practical_hour_Second : this.edu_form.controls.practicalhourSecondCtrl.value,
        practical_hour_Third : this.edu_form.controls.practicalhourThirdCtrl.value,
        practical_hour_Fourth : this.edu_form.controls.practicalhourFourthCtrl.value,
        practical_hour_Fifth : this.edu_form.controls.practicalhourFifthCtrl.value,
        practical_hour_Six : this.edu_form.controls.practicalhourSixCtrl.value,
        practical_hour_Seventh : this.edu_form.controls.practicalhourSeventhCtrl.value,
        practical_hour_Eighth : this.edu_form.controls.practicalhourEighthCtrl.value,
        total_weeks : this.edu_form.controls.totalweeksCtrl.value,
        special_instruction : this.edu_form.controls.specialInstrctionCtrl.value,
      }
  
      this.api.setEducationalValues(edu_data)
      .subscribe(
        (data: any) => {  
          this.ref.close(data);
          err => console.error(err) 
      });
    }
  }

  dismiss() {
    this.ref.close();
  }

}